/** Marks a metric still fed by seeded/demo data pending a live integration (ad
 *  spend, reviews, historical call volume). Mirrors the concept mock's
 *  "pending live API" caption. */
export default function SeededBadge({ label = 'Demo data — pending live feed' }: { label?: string }) {
  return (
    <span
      data-testid="seeded-badge"
      className="inline-flex items-center rounded-sm border border-gold-dim/40 px-1.5 py-0.5 text-[9px] font-inter uppercase tracking-widest text-gold-dim align-middle"
    >
      {label}
    </span>
  );
}
